<template>
  <footer class="footer-en bg-en-blue text-white py-4 px-3 px-md-5">
    <div class="container-fluid">
      <!-- Title Header Section -->
      <div class="mb-4">
        <h2 class="d-flex align-items-center text-white fw-bold fs-4 mb-1">
          <span class="title-accent-bar me-2"></span>
          JOBCENTER EN STELLENPORTAL
        </h2>
        <div class="text-white-50 fs-7 ms-3 ps-1">
          Ein Service des Jobcenter EN, Ennepe-Ruhr-Kreis
        </div>
      </div>

      <!-- Divider line -->
      <div class="footer-divider mb-4"></div>

      <!-- 4 Columns Grid -->
      <div class="row g-4 mb-4">
        <!-- Col 1: KONTAKT -->
        <div class="col-12 col-md-6 col-lg-3">
          <h3 class="col-heading">KONTAKT</h3>
          <div class="d-flex align-items-start mb-3">
            <b-icon icon="geo-alt" class="address-icon me-2 mt-1 flex-shrink-0" />
            <div class="footer-address-block lh-sm">
              <div class="fw-semibold">Jobcenter EN</div>
              <div>Rheinische Str. 41</div>
              <div>58332 Schwelm</div>
            </div>
          </div>
          <div class="d-flex align-items-center mb-3">
            <b-icon icon="telephone" class="me-2 flex-shrink-0" />
            <a href="tel:02336933993" class="footer-link">02336 / 93-3993</a>
          </div>
          <div class="d-flex align-items-center">
            <b-icon icon="chevron-right" class="me-2 flex-shrink-0 fs-7" />
            <a href="#" class="footer-link">Kontaktformular</a>
          </div>
        </div>

        <!-- Col 2: ÖFFNUNGSZEITEN & STANDORTE -->
        <div class="col-12 col-md-6 col-lg-3">
          <h3 class="col-heading">ÖFFNUNGSZEITEN & STANDORTE</h3>
          <div class="d-flex align-items-center mb-3">
            <b-icon icon="clock" class="me-2 flex-shrink-0" />
            <a href="#" class="footer-link">Öffnungszeiten</a>
          </div>
          <div class="d-flex align-items-center">
            <b-icon icon="geo-alt" class="me-2 flex-shrink-0" />
            <a href="#" class="footer-link">Standorte und Dienststellen</a>
          </div>
        </div>

        <!-- Col 3: SERVICE -->
        <div class="col-12 col-md-6 col-lg-3">
          <h3 class="col-heading">SERVICE</h3>
          <ul class="list-unstyled p-0 m-0">
            <li class="mb-2"><a href="#" class="footer-link">Hilfe</a></li>
            <li class="mb-2"><a href="#" class="footer-link">Über Jobcenter EN</a></li>
            <li class="mb-2"><a href="#" class="footer-link">Serviceportal</a></li>
          </ul>
        </div>

        <!-- Col 4: BARRIEREFREIHEIT & RECHTLICHES -->
        <div class="col-12 col-md-6 col-lg-3">
          <h3 class="col-heading">BARRIEREFREIHEIT & RECHTLICHES</h3>
          <ul class="list-unstyled p-0 m-0">
            <li class="mb-2"><a href="#" class="footer-link">Erklärung zur Barrierefreiheit</a></li>
            <li class="mb-2"><a href="#" class="footer-link">Barriere melden</a></li>
            <li class="mb-2"><a href="#" class="footer-link">Leichte Sprache</a></li>
            <li class="mb-2"><a href="#" class="footer-link">Gebärdensprache</a></li>
            <li class="mb-2"><a href="#" @click.prevent="openPrivacyModal" class="footer-link">Datenschutz</a></li>
            <li class="mb-2"><a href="#" @click.prevent="openPrivacyModal" class="footer-link">Impressum</a></li>
          </ul>
        </div>
      </div>

      <!-- Bottom Bar -->
      <div class="d-flex flex-column flex-md-row justify-content-between align-items-center pt-3 fs-7 text-white-50">
        <div>
          &copy; {{ new Date().getFullYear() }} JOBCENTER EN STELLENPORTAL - Jobcenter Ennepe-Ruhr-Kreis
        </div>
        <div class="mt-2 mt-md-0">
          Technisch unterstützt durch Jobnet.AG
        </div>
      </div>
    </div>

    <b-modal
      v-model="privacyModal"
      hide-header
      ok-only
      size="xl"
      centered
      scrollable
    >
      <div v-html="privacyText"></div>
    </b-modal>
  </footer>
</template>

<script lang="ts">
import { AppModule } from '@/store/modules/app';
import { Component, Vue } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import PrivacyPolicyMixin from '@/mixins/PrivacyPolicyMixin';

@Component
export default class FooterComponentEn extends mixins(PrivacyPolicyMixin) {
  get translation() {
    return AppModule.translation;
  }

  get appSetting() {
    return AppModule.setting || {};
  }

  openPrivacyModal() {
    this.privacyModal = true;
  }
}
</script>

<style lang="scss" scoped>
.footer-en {
  background-color: #114e9b !important;
  color: #ffffff;
  font-family: inherit;

  .title-accent-bar {
    display: inline-block;
    width: 4px;
    height: 1.25rem;
    background-color: #38bdf8;
    border-radius: 1px;
  }

  .footer-divider {
    border-top: 1px solid rgba(255, 255, 255, 0.2);
  }

  .col-heading {
    color: #ffffff;
    font-size: 0.875rem;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.05em;
    padding-bottom: 0.5rem;
    margin-bottom: 1rem;
    border-bottom: 1px solid rgba(255, 255, 255, 0.2);
  }

  .footer-address-block {
    font-size: 0.925rem;
    line-height: 1.4;
    color: #ffffff;
  }

  .address-icon {
    font-size: 1.1rem;
  }

  .footer-link {
    color: #ffffff;
    text-decoration: none;
    font-size: 0.875rem;
    transition: opacity 0.2s ease;

    &:hover {
      color: #ffffff;
      opacity: 0.8;
      text-decoration: underline;
    }
  }

  .fs-7 {
    font-size: 0.8rem;
  }
}
</style>
